import { OpaccMedia } from './classes/opacc.class.media.js';

/**
 * Clientseitige Funktionalität im Modul "Media"
 *
 * @module media
 */

export const opaccMediaPlugin = new OpaccMedia();